export default "__VITE_ASSET__DuSd5djm__"